/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_DeniedInputs */

const en_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are blocked for this site: allow them in the settings of your browser, then come back here.`)
};

/**
* | output |
* | --- |
* | "Notifications are blocked for this site: allow them in the settings of your browser, then come back here." |
*
* @param {Push_DeniedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_denied = /** @type {((inputs?: Push_DeniedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_DeniedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_denied(inputs)
});